import graphqlClient from '@/graphql/graphql-client';
import { useMutation } from '@tanstack/react-query';
import {
  InsertTaskManagerTagDocument,
  type InsertTaskManagerTagMutationVariables,
} from '@/graphql/generated/graphql';

export type TaskManagerTagInsertInput = InsertTaskManagerTagMutationVariables;

export const useInsertTaskManagerTag = () => {
  const mutation = useMutation({
    mutationKey: ['insert-task-manager-tag'],
    mutationFn: (variables: InsertTaskManagerTagMutationVariables) =>
      graphqlClient.request(InsertTaskManagerTagDocument, variables),
  });

  return {
    ...mutation,
    insertTaskManagerTag: mutation.mutate,
    insertTaskManagerTagAsync: mutation.mutateAsync,
  };
};

export const INSERT_TASK_MANAGER_TAG_MUTATION = InsertTaskManagerTagDocument;
